import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import './AboutUsCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

export default class AboutUsCard extends Component {
	constructor(props) {
		super(props);
	}

	render() {

		return (
			<Link className="about_us_card_container" to={this.props.link} onClick={this.props.click}>
				<div className="about_us_card_icon">
					<FontAwesomeIcon icon={this.props.icon} size="5x"/>
				</div>
				<div className="about_us_card_title">
					{this.props.title}
				</div>
				<div className="about_us_card_description">
					{this.props.description}
				</div>
				<div >
					<div className="about_us_card_button">
						<span>FIND OUT MORE</span>
						<FontAwesomeIcon icon={faArrowRight} size="1.5x"/>
					</div>
				</div>
			</Link>
		)
	}
};
